import { McaDocumentType } from '@shared/core';
import _ from 'lodash';
import { forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { UserInfoModel } from '../../../../../../shared/data/src/lib/interface/auth/user-info-model';
import { CofusMedicalDocumentationBodyModel } from '../../../core/interface/documentation/medical-documentation-body-model';
import { MedicalDocumentationModel } from '../../../core/interface/documentation/medical-documentation.model';
import { MedicalDocumentationBodyMapper } from '../../../core/model/mappers/medical-documentation-mapper';
import { MedicalDocumentationResponseMapper } from '../../../core/model/mappers/medical-documentation-response-mapper';
import { MedicalDocumentationBodyDtoUnion } from '../../infrastructure/interface/dto/documentation/medical-documentation-body-dto';
import { DocumentationServiceClientService } from '../../infrastructure/service-client/documentation-service-client.service';

export class ClaimSubmissionHelper {
    private documentationServiceClientService: DocumentationServiceClientService;

    constructor(documentationServiceClientService: DocumentationServiceClientService) {
        this.documentationServiceClientService = documentationServiceClientService;
    }

    public processDocumentationRequest(
        userInfo: UserInfoModel,
        request: CofusMedicalDocumentationBodyModel,
        files?: File[],
    ): Observable<MedicalDocumentationModel> {
        const modifiedRequest = _.cloneDeep(request);

        return this.handleFileUploads(files).pipe(
            switchMap(documentIds => {
                if (documentIds?.length) {
                    modifiedRequest.maskedDocumentIds = documentIds;
                }
                modifiedRequest.id = userInfo?.id as string;
                modifiedRequest.customerId = userInfo?.id as string;
                const requestDto = new MedicalDocumentationBodyMapper().mapModelToDto(modifiedRequest);
                return this.submitDocumentationRequest(requestDto);
            }),
        );
    }

    public handleFileUploads(files?: File[]): Observable<string[] | null> {
        if (!files || files.length === 0) {
            return of(null);
        }
        const uploadObservables = files.map(file => this.documentationServiceClientService.uploadDocument(file, McaDocumentType.CUSTOMER_DOCUMENT));
        return forkJoin(uploadObservables);
    }

    private submitDocumentationRequest(requestDto: MedicalDocumentationBodyDtoUnion): Observable<MedicalDocumentationModel> {
        return this.documentationServiceClientService.setMedicalDocumentation(requestDto).pipe(
            map(result => {
                const model = new MedicalDocumentationResponseMapper().mapDtoToModel(result);
                return model;
            }),
        );
    }
}
